/**
 * Settings API Client
 */

import { fetchApi } from './api';
import type { Role, UserRole, PermissionMatrixEntry, PermissionMatrixData } from '../types/settings';

export const settingsApi = {
    getRoles: () =>
        fetchApi<Role[]>('/settings/roles'),

    getUsers: () =>
        fetchApi<UserRole[]>('/users'),

    createUser: (email: string, roleId: number) =>
        fetchApi<{ id: number }>('/users', {
            method: 'POST',
            body: JSON.stringify({ email, roleId }),
        }),

    updateUser: (id: number, data: { roleId?: number; isActive?: boolean }) =>
        fetchApi<void>(`/users/${id}`, {
            method: 'PUT',
            body: JSON.stringify(data),
        }),

    deleteUser: (id: number) =>
        fetchApi<void>(`/users/${id}`, {
            method: 'DELETE',
        }),

    getPermissionMatrix: () =>
        fetchApi<PermissionMatrixData>('/settings/permission-matrix'),

    updatePermissionMatrix: (permissions: PermissionMatrixEntry[]) =>
        fetchApi<{ updated: number }>('/settings/permission-matrix', {
            method: 'PUT',
            body: JSON.stringify({ permissions }),
        }),

    getEntraUsers: () =>
        fetchApi<{ users: Array<{ email: string; displayName: string }>; message?: string }>(
            '/settings/entra-users'
        ),
};
